import { render, staticRenderFns } from "./applicationAuthorPC.vue?vue&type=template&id=0d92635b&scoped=true&"
import script from "./applicationAuthorPC.vue?vue&type=script&lang=js&"
export * from "./applicationAuthorPC.vue?vue&type=script&lang=js&"
import style0 from "./applicationAuthorPC.vue?vue&type=style&index=0&id=0d92635b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d92635b",
  null
  
)

export default component.exports